import img1 from "./assets/logo1.svg";
import img2 from "./assets/logo2.svg";
import img4 from "./assets/logo4.svg";
import img5 from "./assets/logo5.svg";
import img6 from "./assets/logo6.svg";

import img_bmw from "./assets/bmw.svg";

import "./Companies.css";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);
function Companies() {
  useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add(
      {
        isDesktop: "(min-width: 900px)",
        isMobile: "(max-width: 899px)",
      },
      (context) => {
        let { isMobile } = context.conditions;

        gsap.fromTo(
          ".companies-logo",
          {
            translateY: isMobile ? 20 : -40, // Less movement on mobile
            autoAlpha: 0,
            filter: "blur(20px)",
          },
          {
            scrollTrigger: {
              trigger: ".companies",
              start: "top 85%", // Trigger earlier on mobile
            },
            stagger: isMobile ? 0.02 : 0.05, // Faster stagger on mobile
            translateY: 0,
            autoAlpha: 1,
            filter: "blur(0px)",
            duration: 0.5,
            ease: "power1.out",
          }
        );
      }
    );
  });

  return (
    <div className="companies">
      <div className="companies-grid">
        <img className="companies-logo" src={img_bmw} alt="BMW Group" />
        <img className="companies-logo" src={img1} alt="Company logo 1" />
        <img className="companies-logo" src={img2} alt="Company logo 2" />
        <img className="companies-logo" src={img4} alt="Company logo 4" />
        <img className="companies-logo" src={img6} alt="Company logo 6" />
        <img className="companies-logo" src={img5} alt="Company logo 5" />
      </div>
    </div>
  );
}

export default Companies;
